export class LoadFinOpsAwsAccountsHistoricalData {
    static type = '[FINPS][AWS][ACCOUNTS] LoadFinOpsAwsAccountsHistoricalData'
}

export class LoadDataTableFinOpsAwsAccounts {
    static type = '[FINPS][AWS][ACCOUNTS] LoadDataTableFinOpsAwsAccounts'
}

export class LoadFinOpsAwsAccountsChartsData {
    static type = '[FINPS][AWS][ACCOUNTS] LoadFinOpsAwsAccountsChartsData'
}

export class LoadFinOpsAwsAccountsChartsFilteredData {
    static type = '[FINPS][AWS][ACCOUNTS] LoadFinOpsAwsAccountsChartsFilteredData'
}